<template>
	<tr class="even:bg-gray-300 rounded hover:bg-gray-400" :class="{ 'cursor-pointer': clickable }" @click="$emit('click', $event)">
		<slot />
	</tr>
</template>

<script>
export default {
	name: 'BaseRow',
	props: {
		clickable: { default: true, type: Boolean },
	},
};
</script>

<style scoped></style>
